<template>
  <div>
    <router-view></router-view>
    <app-footer v-if="footer_show" @select-footer="navToPath"></app-footer>
  </div>
</template>

<script>
import header from '@/components/header/header.vue'
import footer from '@/components/footer/footer.vue'

export default {
  components: {
    'app-header': header,
    'app-footer': footer
  },
  data () {
    return {
      header_show: true, // true和false控制头部显示或者不显示
      footer_show: true, // true和false控制底部显示或者不显示
      curPage: '/query'
    }
  },
  methods: {
    clickGridItem (e) {
      console.log(e.type)
      // window.location.href = e.type + '.html'
      // this.$router.push({ path: e.type, title: { title: '我是谁' } })
    },
    navToPath (tag, url) {
      console.log(tag + url)
      if (url !== this.$route.path) {
        this.$router.replace(url)
      }
    }
  },
  mounted () {
  }

}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/project/home/home.vue